<div id="selectProviderListItem-listItem-{{ providerSelectionDetail.provider.id }}" class="select-provider-list-item-container" [ngClass]="{ 'uninterested-provider': isUninterestedProvider }">
  <div class="provider">
    <h3 id="selectProviderListItem-cell-providerName-{{ providerSelectionDetail.provider.id }}" data-private>
      {{ providerSelectionDetail.provider.name }}
    </h3>
    <div>
      <small
        *ngIf="providerSelectionDetail.provider.emailAddress"
        id="selectProviderListItem-cell-providerEmail-{{ providerSelectionDetail.provider.id }}"
        data-private
      >
        {{ providerSelectionDetail.provider.emailAddress }}
      </small>
    </div>
    <div>
      <small
        *ngIf="providerSelectionDetail.provider.phoneNumber"
        id="selectProviderListItem-cell-phoneNumber-{{ providerSelectionDetail.provider.id }}"
        [ngClass]="{ 'call-number': isUninterestedProvider }"
        data-private
      >
        {{ providerSelectionDetail.provider.phoneNumber | phone }}
      </small>
    </div>
  </div>
  <div id="selectProviderListItem-cell-pickupTime-{{ providerSelectionDetail.provider.id }}" class="action">
    <button
      id="selectProviderListItem-button-select-{{ providerSelectionDetail.provider.id }}"
      mat-raised-button
      [color]="selectButtonColor"
      (click)="selectProvider()"
    >
      Select {{ selectionText }}
    </button>
  </div>
</div>
